module.exports = __webpack_public_path__ + "static/assets/8a53fddb0dd709c111a062795a3dd790.png";